import type { ICellRendererParams } from 'ag-grid-enterprise';
import { isFunction } from 'lodash-es';
import { Button, IconButton } from '../Button';
import { IconName } from '../Icons';
import type { AgGridButtonProps } from './types';

export function AgGridButton({
  onClick,
  node,
  api,
  children,
  size,
  disabled,
  hide,
  startIcon,
  endIcon,
  ...props
}: Omit<ICellRendererParams, 'disabled'> & AgGridButtonProps) {
  if (node.data == null || (hide && hide(node.data))) {
    return null;
  }
  return children ? (
    <Button
      size={size}
      onClick={e => {
        e.stopPropagation();
        onClick({ node, api });
      }}
      disabled={isFunction(disabled) ? disabled({ node, api }) : disabled}
      data-testid="ag-grid-button"
      startIcon={startIcon}
      endIcon={endIcon}
      {...props}
    >
      {children}
    </Button>
  ) : startIcon || endIcon ? (
    <IconButton
      size={size}
      onClick={e => {
        e.stopPropagation();
        onClick({ node, api });
      }}
      icon={(startIcon || endIcon) ?? IconName.Circle}
      disabled={isFunction(disabled) ? disabled({ node, api }) : disabled}
      data-testid="ag-grid-button"
      {...props}
    />
  ) : null;
}
